import { APICore } from 'helpers/api/apiCore'
import {
  CadastroInicialReq,
  RdStationProps
} from 'models/cadastros/cadastroInicial/types'

const api = new APICore()

export function salvarCadastroInicial(params: CadastroInicialReq) {
  return api.create(`CadastroCliente/inicial`, params)
}

export function getPoliticaPrivacidade() {
  return api.get(`pdf/politica-privacidade`)
}

export function criarRDStation(params: Partial<RdStationProps>) {
  return api.create(`RdStation/CriarContato`, params)
}
export function atualizarContatoRDStation(
  uuid: string | null,
  params: Partial<RdStationProps>
) {
  return api.update(`RdStation/AtualizarContato/${uuid}`, params)
}
